import React, { useEffect, useState } from 'react';
import { useSelector, connect } from 'react-redux';
import s from './index.module.css';
import Button from '../Button';
import messagesApi from '../../api/messages';
import actions from '../../store/actions/messages';
import { getCurrentDialogId, getSenderId } from '../../store/selectors';

const ExpertFeedback = ({
    messageId,
    chatWindowRef,
    saveFeedback,
    setMessageFront,
    expertId
}) => {
    const senderId = useSelector(getSenderId);
    const currentDialogId = useSelector(getCurrentDialogId);
    const [feedback, setFeedback] = useState('');
    const [showFeedback, setShowFeedback] = useState(false);

    const handleSaveFeedback = (event, message = feedback) => {
        event.preventDefault();
        messagesApi.saveFeedback(currentDialogId, expertId, senderId, message, messageId)
        saveFeedback()

        if (message) {
            setMessageFront(message, senderId)
        }
    }

    useEffect(() => {
        const chatWindowEl = chatWindowRef && chatWindowRef.current && chatWindowRef.current.contentWrapperEl
        if (showFeedback && chatWindowEl) {
            chatWindowEl.scrollTo({
                top: chatWindowEl.scrollHeight,
                behavior: 'smooth',
              });
        }
    }, [showFeedback, chatWindowRef])

    return <form onSubmit={(e) => handleSaveFeedback(e)} className={s.wrapper}>
        <div>
        {
            showFeedback && <div className={s.content}>
                <div className={s.title}>
                    Ваш отзыв эксперту. Эксперт не видит отзыв
                </div>
                <textarea required value={feedback} onChange={(e) => setFeedback(e.target.value)} className={s.feedback} rows={11}></textarea>
            </div>
        }
        <div className={s.buttons}>
            {
                !showFeedback && <Button view="button" background="white" onClick={() => setShowFeedback(true)} className={s.button}>Написать отзыв</Button>
            }
            {
                showFeedback && <Button type="submit" view="button" background="blue" className={s.button}>Отправить</Button>
            }
            <Button onClick={(e) => handleSaveFeedback(e, null)} view="button" background="white" className={s.button}>Вернуться к эксперту</Button>
        </div>
        </div>
    </form>
}

export default connect(() => ({}), actions)(ExpertFeedback)